import { ColumnsType } from 'antd/lib/table'
import { IColumns } from 'egi/types'
import commomColumns, { columnBlockUser } from 'egi/views/UsersTable/DataTables/commomDataTable'

const columns = ({ blockUser }: IColumns): ColumnsType<Object> => [
  ...commomColumns,
  columnBlockUser(blockUser)
]

export default columns
